app.service('subscriptionWarranties', function (loading, modal, subscriptionResignForm, ajaxErrorHandler) {

	let insuranceIdentifier;

	function init() {

		setEvents();
	}

	function setEvents() {
		$('body')
			.on('click', '.js-subscription-warranties-resign', handleWarrantyResignClick)
			.on('click', '.js-subscription-warranties-details', handleSubscriptionServiceDetailsClick)
			.on('click', '#warranty-resign-modal .remodal-close', function() {
				sendUA("Przycisk X");
			});

		$(document)
			.on('closed', '#warranty-resign-modal', function (event, data) {
				if (data.reason && data.reason === 'outsideClick') {
					sendUA("Kliknięcie poza warstwę");
				}
			});
	}

	function handleSubscriptionServiceDetailsClick () {
		const recurringPaymentId = $(this).data('recurring-payment-id');
		loadSubscriptionWarrantyDetails(recurringPaymentId);
	}


	function handleWarrantyResignClick() {
		insuranceIdentifier = $(this).data('id');
		loadWarrantyResignForm();
	}

	function loadSubscriptionWarrantyDetails(recurringPaymentId) {
		const $box = $(`.subscription-item[data-id="${recurringPaymentId}"]`);
		if (!$box.length) {
			return;
		}
		loading.start();
		return $.ajax({
			url: '/customer-subscription-warranty-payment-list.ltr',
			data: {
				recurringPaymentId
			},
			success: (html) => {
				$('.subscription-item-details', $box).html(html);
			},
			error: ajaxErrorHandler.createFailHandler('subscriptionWarranties.loadSubscriptionWarrantyDetails'),
			complete: () => {
				loading.stop();
			}
		});
	}

	/**
	 * Doczytuje formularz z ankietą, który pozwala użytkownikowi podać powód rezygnacji z gwarancji
	 */
	function loadWarrantyResignForm() {
		loading.start();

		$.ajax({
			url: '/customer-warranty-subscription-close-reason.ltr',
			type: 'GET',
			success(questionnaireHtml) {
				openModal(questionnaireHtml);
			},
			error: ajaxErrorHandler.createFailHandler('subscriptionWarranties.loadWarrantyResignForm'),
			complete() {
				loading.stop();
			}
		});
	}

	function openModal(questionnaireHtml) {
		modal.generate({
			id: 'warranty-resign-modal',
			header: 'Rezygnacja z ubezpieczenia',
			content: questionnaireHtml,
			buttons: [
				{
					text: 'Wróć',
					cssClass: 'cancel-resignation',
					click: function () {
						modal.close();
						sendUA('Przycisk Wróć');
					}
				},
				{
					text: 'Potwierdzam rezygnację',
					cssClass: 'confirm-resignation is-disabled',
					click: confirmSubscriptionWarrantyResign
				}
			]
		});
	}

	function confirmSubscriptionWarrantyResign() {
		loading.start();

		const {closeReasonName, closeReasonDescription} = subscriptionResignForm.getResignFormData();

		$.ajax({
			url: '/customer-warranty-subscription-close.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				insuranceIdentifier,
				closeReasonName,
				closeReasonDescription
			}),
			success: function (result) {
				if (result.status === 'SUCCESS') {
					window.location.hash = 'ubezpieczenia';
					location.reload();
				} else {
					loading.stop();
					modal.alert(result.messages[0]);
				}
			},
			error: ajaxErrorHandler.createFailHandler('subscriptionWarranties.confirmSubscriptionWarrantyResign'),
			complete() {
				loading.stop();
			}
		});
	}

	function sendUA(reason) {
		UA.push({
			event: "visitorInteraction",
			eventCategory: "InsuranceQuestionnaire",
			eventAction: "Zamknięcie popupa",
			eventLabel: reason
		});
	}

	return {
		init,
		loadSubscriptionWarrantyDetails
	};
});